function normalizeCssFontFamily(cssFontFamily) {
    if (typeof cssFontFamily === 'string') {
        return cssFontFamily.toLowerCase().replace(/['"\s]/g, '')
    }
}

module.exports = {
    normalizeCssFontFamily
}



// WEBPACK FOOTER //
// ./src/utils/fontUtils.js